import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=704bb40e&scoped=true&"
import script from "./Add.vue?vue&type=script&lang=ts&"
export * from "./Add.vue?vue&type=script&lang=ts&"
import style0 from "./Add.vue?vue&type=style&index=0&id=704bb40e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704bb40e",
  null
  
)

export default component.exports